"use strict";

require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBHeader;
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Search_grey = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search_grey.svg"));
var _chevron_down_navbar = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron_down_navbar.svg"));
var _navbar_open = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/navbar_open.svg"));
var _index = require("../index");
const _excluded = ["logo", "headerContent", "extraClasses", "selectedMenuItem"];
/*
 * SVB Header
 * <SVBHeader headerContent={headerJSON} />
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/**
 * SVBHeader
 * @param headerContent: json array of header-link objs
 * see ../readme.MD for sample body
 * @param extraClasses: additional styling classes
 * @param selectedMenuItem: to hightlight the menu item in dropdown
 * @returns header HTML with content
 */

function SVBHeader(_ref) {
  let {
      logo,
      headerContent,
      extraClasses,
      selectedMenuItem
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [subMenuState, setSubMenu] = (0, _react.useState)([]);
  const {
    onSearchClick,
    showSearch
  } = props;
  const [onMouseHover, setMouseHover] = (0, _react.useState)(false);
  const [selMenuItem, setSelMenuItem] = (0, _react.useState)(selectedMenuItem !== null && selectedMenuItem !== void 0 ? selectedMenuItem : "");
  const extClasses = extraClasses ? extraClasses : "";
  // svb-header needs to be applied by default, any other additional classes
  // are added before render
  const Classes = "svb-header h-auto" + extClasses;
  const location = (0, _reactRouterDom.useLocation)();
  const ref = (0, _react.useRef)();
  const [isMenuOpen, setIsMenuOpen] = (0, _react.useState)(false);
  const [selectedParentVal, setSelectedParentVal] = (0, _react.useState)("");
  (0, _react.useEffect)(() => {
    const checkIfClickedOutside = e => {
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isMenuOpen]);
  (0, _react.useEffect)(() => {
    setSelMenuItem(selectedMenuItem);
  }, [selectedMenuItem]);
  (0, _react.useEffect)(() => {
    const obj = (0, _index.GetParentObject)(headerContent);
    if (obj) {
      setSelectedParentVal(obj === null || obj === void 0 ? void 0 : obj.name);
    } else {
      setSelectedParentVal("");
    }
  }, [location.pathname]);
  const getNavLinkClass = menuParentname => {
    return menuParentname === selectedParentVal ? "nav-item active" : "nav-item";
  };
  const closeDropdown = () => {
    document.querySelectorAll(".nav-item").forEach(i => {
      if (i.classList.contains("navbar_dropdown--open")) {
        i.classList.replace("navbar_dropdown--open", "navbar_dropdown");
        i.classList.add("navbar_dropdown");
      }
    });
  };
  const generateSubmenuSlug = str => {
    try {
      str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
    } catch (error) {
      console.log(error);
    }
  };

  // to build the menuItem from headerContent  navbar_item navbar_item--active navbar_dropdown navbar_dropdown--open
  const menuItems = (menuItem, i) => menuItem.subMenu ? /*#__PURE__*/_react.default.createElement("li", {
    key: i,
    onClick: () => {
      setSubMenu([]), (subMenuState === null || subMenuState === void 0 ? void 0 : subMenuState.length) > 0 ? setIsMenuOpen(!isMenuOpen) : setIsMenuOpen(true);
    },
    className: "navbar_item navbar_item--active navbar_dropdown navbar_dropdown  " + getNavLinkClass(menuItem.name)
  }, /*#__PURE__*/_react.default.createElement("a", {
    role: "button",
    className: "nav-link"
  }, menuItem.name, /*#__PURE__*/_react.default.createElement("span", {
    className: "nav_item_dd_indicator"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _chevron_down_navbar.default,
    alt: "Dropdown Icon",
    width: 21,
    height: 20
  }))), isMenuOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "navbar_dropdown_content position-absolute mt-2 mw-100 p-2 gap-4"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    key: i,
    className: "navbar_links list-unstyled p-0 m-0 "
  }, menuItem.subMenu && menuItem.subMenu.map(subMenuItems)), (subMenuState === null || subMenuState === void 0 ? void 0 : subMenuState.length) > 0 && /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled ps-1 m-0 navbar_links",
    id: "cba_links"
  }, subMenuState === null || subMenuState === void 0 ? void 0 : subMenuState.map((i, ind) => {
    var _i$subMenu, _i$subMenu$;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "navbar_link",
      key: ind
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "nav_link_content d-inline-flex align-items-center text-decoration-none gap-1 paragraph",
      href: (i === null || i === void 0 || (_i$subMenu = i.subMenu) === null || _i$subMenu === void 0 ? void 0 : _i$subMenu.length) > 0 ? i === null || i === void 0 || (_i$subMenu$ = i.subMenu[0]) === null || _i$subMenu$ === void 0 ? void 0 : _i$subMenu$.link : i.link
    }, i.name));
  })))) : /*#__PURE__*/_react.default.createElement("li", {
    className: getNavLinkClass(menuItem.name) + " navbar_item",
    key: i
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    className: "nav-link",
    to: menuItem.link,
    title: menuItem.description ? menuItem.description : ""
  }, menuItem.name));
  // to build submenuItems
  const subMenuItems = (submenuItem, i) => {
    var _submenuItem$subMenu;
    return (submenuItem === null || submenuItem === void 0 || (_submenuItem$subMenu = submenuItem.subMenu) === null || _submenuItem$subMenu === void 0 ? void 0 : _submenuItem$subMenu.length) > 0 ? /*#__PURE__*/_react.default.createElement("li", {
      key: i,
      "data-testid": "nested-subMenu",
      className: onMouseHover ? "navbar_link" : selMenuItem === generateSubmenuSlug(submenuItem.name) ? "navbar_link navbar_item--active" : "navbar_link",
      onMouseOver: () => setMouseHover(true),
      onMouseOut: () => setMouseHover(false),
      onClick: e => {
        var _submenuItem$subMenu2;
        setSubMenu([]);
        e.stopPropagation();
        e.preventDefault();
        setSubMenu(submenuItem === null || submenuItem === void 0 || (_submenuItem$subMenu2 = submenuItem.subMenu) === null || _submenuItem$subMenu2 === void 0 ? void 0 : _submenuItem$subMenu2.filter(x => (x === null || x === void 0 ? void 0 : x.status) !== 0));
        setSelMenuItem(generateSubmenuSlug(submenuItem.name));
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      role: "button",
      className: "nav_link_content d-inline-flex align-items-center text-decoration-none gap-1 paragraph"
    }, " ", submenuItem.name, " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "nav_item_dd_indicator ps-1"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _navbar_open.default,
      alt: "Sub Menu Open Icon",
      width: 14,
      height: 16
    })))) : /*#__PURE__*/_react.default.createElement("li", {
      className: "navbar_link",
      key: i,
      onMouseOver: () => setMouseHover(true),
      onMouseOut: () => setMouseHover(false),
      id: "subMenu"
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "nav_link_content d-inline-flex align-items-center text-decoration-none gap-1 paragraph",
      to: submenuItem.link,
      onClick: () => {
        closeDropdown();
        setSelMenuItem("");
      }
    }, submenuItem.name));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: Classes
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: "d-flex gap-2 position-sticky align-items-center navbar-expand-md w-100 top-0 start-0 px-3 navbar pd-bottom",
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex col-10 container-fluid m-0 d-md-flex justify-content-md-start pl-md-16 d-sm-flex justify-content-sm-start pl-sm-16 grid-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-baseline"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "navbar-toggler",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#svb-main-nav"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "navbar-toggler-icon"
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: "/",
    className: "navbar-brand svb-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "SVB Developer Portal",
    width: 191,
    height: 50
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "collapse navbar-collapse",
    id: "svb-main-nav"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "navbar-nav",
    tabIndex: "0",
    ref: ref
  }, headerContent && headerContent.map(menuItems)))), showSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-fill justify-content-end"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: onSearchClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Search_grey.default,
    alt: "search icon",
    role: "presentation",
    width: "20",
    height: "20"
  })))));
}